/**
 * Runtime configuration for the dashboard.
 *
 * The backend base URL is read from Vite's `import.meta.env` (`VITE_API_URL`),
 * falling back to the local dev backend. Centralized here so the client factory
 * and any deep links share one source.
 */

/** Backend REST + Socket.IO base URL. Prod builds default to the hosted API. */
export const API_BASE_URL: string =
  (import.meta.env?.VITE_API_URL as string | undefined) ??
  (import.meta.env?.PROD ? 'https://api.hotline.red' : 'http://localhost:8003');

/** Public install base (where the widget script is served from) for snippets. */
export const WIDGET_CDN_URL: string =
  (import.meta.env?.VITE_WIDGET_CDN_URL as string | undefined) ??
  'https://cdn.hotline.red';

/**
 * Google OAuth **Web** client id (public). When set, the login page renders a
 * "Continue with Google" button; when blank, the button is hidden and only
 * email+password / magic-link are offered. Must equal the backend's
 * `GOOGLE_CLIENT_ID` (it's the verified `aud`).
 */
export const GOOGLE_CLIENT_ID: string =
  (import.meta.env?.VITE_GOOGLE_CLIENT_ID as string | undefined) ?? '';

/**
 * Public key of the internal widget instance the dashboard dogfoods (the same
 * "recursive" feedback widget shown on the promo). Defaults to the local demo
 * key — `seed-demo` already allowlists `http://localhost:8000`, so dev works out
 * of the box. In prod, set `VITE_HOTLINE_WIDGET_KEY` to the internal pk_live key.
 */
export const HOTLINE_WIDGET_KEY: string =
  (import.meta.env?.VITE_HOTLINE_WIDGET_KEY as string | undefined) ?? 'pk_demo_local';
